module.exports = __webpack_public_path__ + "static/media/Gallary5.3300e6cf.webp";